import { render, staticRenderFns } from "./semesterTopic.vue?vue&type=template&id=e47cf9b0&scoped=true&"
import script from "./semesterTopic.vue?vue&type=script&lang=js&"
export * from "./semesterTopic.vue?vue&type=script&lang=js&"
import style0 from "./semesterTopic.vue?vue&type=style&index=0&id=e47cf9b0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47cf9b0",
  null
  
)

component.options.__file = "semesterTopic.vue"
export default component.exports